import { createAction, props } from '@ngrx/store';
import { CognitoUser } from '@aws-amplify/auth'; 
import { UserAttributes } from './auth.reducer';

export const setEmail = createAction('[Auth] Set Email', props<{payload: string}>());
export const setOpenSesame = createAction('[Auth] Set Open Sesame', props<{payload: string}>());
export const setUser = createAction('[Auth] Set User', props<{payload: CognitoUser | undefined}>());
export const setAttributes = createAction('[Auth] Set Attributes', props<{payload: UserAttributes | undefined}>());
export const setIsPendoInitialised = createAction('[Auth] Set Is Pendo Initialised', props<{payload: boolean}>());
export const setSchoolName = createAction(
  '[Auth] Set School Name',
  props<{ payload: string | undefined }>()
);